import React from 'react'

const EmailVerificationBackupOffer = (props) => {
  const {
    onAddBackup, onSkip, onNeverAskAgain, showNeverAskAgain,
  } = props

  return (
    <div className='emailVerificationFlow-backupOffer'>
      <div className='emailVerificationFlow-title'>Add a backup email address</div>
      <div className='emailVerificationFlow-description'>
        A backup email address covers you if you ever lose access to your primary email address.
      </div>
      <button type='button' className='btn btn--blue btn--large' onClick={onAddBackup}>
        Add backup email address
      </button>
      <div className='emailVerificationFlow-backupOffer-links'>
        {showNeverAskAgain && (
          <button type='button' className='emailVerificationFlow-linkBtn' onClick={onNeverAskAgain}>
            Don&apos;t ask me again
          </button>
        )}
        <button type='button' className='emailVerificationFlow-linkBtn' onClick={onSkip}>
          Not now
        </button>
      </div>
    </div>
  )
}

export default EmailVerificationBackupOffer
